import { SelectFilter } from './SelectFilter'
import { TextFilter } from './TextFilter'

export const TableFilters = {
  Select: SelectFilter,
  Text: TextFilter,
}
